import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const QuestionView = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  // ⬇️ get values from URL
  const params = new URLSearchParams(window.location.search);
  const testId = params.get("testId");
  const qno = params.get("qno");
  const userAnswer = params.get("ans");

  const apiUrl = `https://testresult.omegacareerinstitute.com/admin/welcome/get_test_question?testId=${testId}&qno=${qno}`;

  useEffect(() => {
    const load = async () => {
      try {
        const res = await fetch(apiUrl);
        const json = await res.json();
        setData(json);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [apiUrl]);

  if (loading) return <p className="p-3">Loading…</p>;
  if (!data) return <p className="p-3 text-danger">No data found</p>;

  // build image URL
  const imageUrl = `https://omegacareerinstitute.com/testresult/admin/questioncrop/${data.img_url}`;
  const solution = `https://omegacareerinstitute.com/testresult/admin/questioncrop/${data.solutions_url}`;
  const correctOption = data.answer;

  const youtubeUrl = data.youtubelink || "#";

  return (
    <div className="container py-3">

      {/* QUESTION IMAGE */}
     <div className="card shadow-sm p-3 mb-3">
  <h6 className="fw-bold mb-2">Question</h6>

  <div style={{ textAlign: "center" }}>
    <img
      src={imageUrl}
      alt="Question"
      className="img-fluid rounded"
      style={{
        maxWidth: "100%",
        height: "auto",
        objectFit: "contain",
      }}
    />
  </div>
</div>


      {/* OPTIONS (same image, highlight by A/B/C/D) */}
    <div className="card shadow-sm p-3 mb-3">
  <h6 className="fw-bold mb-2">Options</h6>

  {/* HORIZONTAL OPTIONS */}
  <div className="d-flex justify-content-between flex-wrap">
    {["A", "B", "C", "D"].map((label) => {
      const isCorrect = correctOption === label;
      const isUserWrong =
        userAnswer === label && userAnswer !== correctOption;

      return (
        <div
          key={label}
          className="d-flex flex-column align-items-center rounded "
          style={{
        
            backgroundColor: isCorrect
              ? "#e6ffea"
              : isUserWrong
              ? "#ffe6e6"
              : "#fff",
          }}
        >
          <div
            style={{
              width: "35px",
              height: "35px",
              borderRadius: "50%",
              backgroundColor: isCorrect
                ? "green"
                : isUserWrong
                ? "red"
                : "#ccc",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "white",
              fontWeight: "bold",
            }}
          >
            {label}
          </div>

        
        </div>
      );
    })}
  </div>

  {/* USER ANSWER SECTION */}
  <div className="mt-3">
    <strong>Your Answer: </strong>
    {userAnswer && userAnswer !== ""
      ? userAnswer
      : <span className="text-danger">Skip</span>}
  </div>
  <div className="mt-3">
    <strong>Correct Answer: </strong>{correctOption}
  
  </div>
</div>


      {/* SOLUTION */}
      {solution && solution !== "#" && (
      <div className="card shadow-sm p-3 mb-3">
        <h6 className="fw-bold">Solution</h6>
 <div style={{ textAlign: "center" }}>
    <img
      src={solution}
      alt="Question"
      className="img-fluid rounded"
      style={{
        maxWidth: "100%",
        height: "auto",
        objectFit: "contain",
      }}
    />
  </div>
        {/* render HTML from API */}
       
      </div>
      )}
      {/* YOUTUBE */}
      {youtubeUrl && youtubeUrl !== "#" && (
        <div className="text-center">
          <a
            href={youtubeUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-danger btn-lg w-100"
          >
            📺 Watch Explanation on YouTube
          </a>
        </div>
      )}
    </div>
  );
};

export default QuestionView;
